import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";

import { FeatureUnavailableContainer } from "./feature-unavailable.container";

const DIRECTIVES: any[] = [FeatureUnavailableContainer];

@NgModule({
	imports: [CoreModule, CommonModule, CoreContentModule, GlobalModule, RouterModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class FeatureUnavailableModule {}
